import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const AddButton = ({ className = '', ...props }) => {
    return (
        <button
            type="button"
            title="Add"
            className={`btn btn-primary d-flex align-items-center ${className}`}
            {...props}
        >
            <FontAwesomeIcon icon={faPlus} className='btn-icon me-1' />
            <span className="btn-label">Add</span>
        </button>
    )
}

export default AddButton